import React from 'react';
import { useTranslation } from 'react-i18next';
import Immutable from 'immutable';
import InformationOverlay from '../../../components/InformationOverlay';

import { getPromotionAdjustmentItems } from './helpers';

import './style.scss';

const CouponOverlay = ({ products }) => {
  const { t } = useTranslation();
  const items = getPromotionAdjustmentItems(products);

  return (
    <InformationOverlay
      overlayKey="CartSummary__discount_code"
      title={t('cart.discount')}
    >
      <div className="CartSummary__coupon-overlay">
        {items.map(
          ({ key, productTitle, couponName: name, amount, percentage }) => {
            const couponName = name || t('cart.discount_code_label');
            const conditionText = percentage
              ? t('cart.discount_overlay_condition', {
                percentage: Math.round(percentage * 100),
              })
              : null;
            return (
              <div key={key} className="CartSummary__coupon-overlay__item">
                {productTitle && (
                  <div className="CartSummary__coupon-overlay__row">
                    <span>{productTitle}</span>
                    <span>{amount}</span>
                  </div>
                )}
                <div className="CartSummary__coupon-overlay__label">
                  {couponName}
                </div>
                {conditionText && (
                  <div className="CartSummary__coupon-overlay__condition">
                    {conditionText}
                  </div>
                )}
              </div>
            );
          },
        )}
      </div>
    </InformationOverlay>
  );
};

CouponOverlay.defaultProps = {
  products: Immutable.List(),
};

export default CouponOverlay;
